<template>
  <div class="pb-3">
    <va-card :title="$t(`postsSendNotification.title`)">
      <div class="row">
        <div class="flex md12">
          <div class="form-group mb-2">
            <label>{{$t('postsSendNotification.forms.titleLabel')}}</label>
            <p>{{post.title}}</p>
          </div>
          <div class="form-group mb-2">
            <label>{{$t('postsSendNotification.forms.bodyLabel')}}</label>
            <p>{{post.subtitle}}</p>
          </div>
          <div v-if="imageUrl" class="form-group mb-2">
            <label>{{ $t('postsSendNotification.forms.imageLabel') }}</label>
            <div class="mt-1">
              <img
                :src="imageUrl"
                alt="Preview da Imagem"
                style="max-width: 100%; max-height: 180px; border-radius: 6px; object-fit: cover; display: block; border: 1px solid #e0e0e0;"
              />
            </div>
          </div>
          <div class="form-group">
            <va-select
              :label="$t('postsSendNotification.forms.clubLabel')"
              v-model="club"
              textBy="name"
              keyBy='id'
              no-clear
              searchable
              :placeholder="$t('postsSendNotification.forms.clubPlaceholder')"
              :noOptionsText="$t('postsSendNotification.forms.clubNoOption')"
              maxHeight='200px'
              :options="clubs.length > 0 ? clubs : []"
            />
          </div>
        </div>
        <div class="d-flex mt-1 mb-1">
          <va-button
            type="submit"
            :disabled="buttonSubmitDisabled"
            color="success"
            class="my-0"
            @click="send">
            {{ textSubmit }}
          </va-button>
          <va-button
            type="button"
            class="my-0"
            color="danger"
            @click="cancel">
            {{ $t("forms.cancel") }}
          </va-button>
        </div>
      </div>
    </va-card>
  </div>
</template>

<script>
export default {
  name: 'postsSendNotification',
  props: {
    post: {
      required: true,
    },
    clubs: {
      type: Array,
      required: true,
    },
  },
  // created () {
  //   if (this.clubs.length > 0) {
  //     this.club = this.post.club
  //   }
  // },
  data () {
    return {
      club: {
        id: 0,
        name: 'Geral',
        code: 'geral',
      },
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.send'),
    }
  },
  computed: {
    imageUrl () {
      if (!this.post || !this.post.image) return ''
      if (this.post.image.includes('http')) {
        return this.post.image
      }
      const cdn = (this.$store.getters['environment/cdn'] || 'https://cdn.s1live.com').replace(/\/+$/, '')
      return `${cdn}/posts/${this.post.image}`
    },
  },
  methods: {
    cancel () {
      this.$emit('close', false)
    },
    send () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.sending')
      const self = this
      if (this.club.id !== -1) {
        this.$axios.post(
          '/api/messaging/notice',
          {
            topic: this.club.code.toLowerCase().replaceAll(' ', ''),
            title: this.post.title,
            body: this.post.subtitle,
            slug: this.post.slug,
            date: this.post.date,
            image: this.post.image,
          },
        ).then(response => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.send')
          self.showToast(
            self.$t('toasts.successSend'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
          .catch(e => {
            self.buttonSubmitDisabled = false
            self.textSubmit = self.$t('forms.send')
            self.showToast(
              self.$t('toasts.errorSend'),
              {
                icon: 'fa-check',
                position: 'top-right',
                duration: 1000,
                fullWidth: false,
              },
            )
          })
      }
    },
  },
}
</script>
